import clsx from 'clsx'

interface TransferCardProps {
  transfer: {
    id: string
    player_name: string
    position?: string
    from_school?: string
    from_conference?: string
    to_school?: string
    to_conference?: string
    status: string
    transfer_date?: string
  }
}

const STATUS_STYLES: Record<string, string> = {
  entered: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  committed: 'bg-zone-safe/10 text-zone-safe border-zone-safe/30',
  withdrawn: 'bg-slate-500/10 text-slate-400 border-slate-500/30',
}

export function TransferCard({ transfer }: TransferCardProps) {
  return (
    <div className="card p-4 hover:border-accent/30 transition-colors">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-white">{transfer.player_name}</h3>
          {transfer.position && (
            <span className="text-xs text-slate-500">{transfer.position}</span>
          )}
        </div>
        <span className={clsx(
          'text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border',
          STATUS_STYLES[transfer.status] || STATUS_STYLES.entered,
        )}>
          {transfer.status}
        </span>
      </div>

      <div className="flex items-center gap-2 text-sm">
        <span className="text-slate-300 truncate">{transfer.from_school || '—'}</span>
        <svg className="w-4 h-4 text-accent shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
        <span className={clsx('truncate', transfer.to_school ? 'text-white font-medium' : 'text-slate-500')}>
          {transfer.to_school || 'TBD'}
        </span>
      </div>

      {(transfer.from_conference || transfer.to_conference) && (
        <div className="flex items-center gap-2 text-xs text-slate-500 mt-1">
          <span>{transfer.from_conference || ''}</span>
          {transfer.from_conference && transfer.to_conference && <span>&rarr;</span>}
          <span>{transfer.to_conference || ''}</span>
        </div>
      )}
    </div>
  )
}
